export default __webpack_public_path__ + "static/contact3-8d2f776ec5696b3ade4622de4f0ddbc8.svg";